/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
export default function PageContent(props: any) {
  return <div style={{ marginLeft: 15, marginRight: 15 }}>{props.children}</div>;
}
